import "./style.scss";
import SelectFilialUI from "@UI/SelectFilialUI";
import { useEffect, useMemo, useState } from "react";

import filialicon from "../img/icon/Icon_filial.svg";
import filial100 from "../img/icon/Icon_filial_100.svg";
import filial50 from "../img/icon/Icon_filial_50.svg";
import geo from "../img/icon/Icon_geo.svg";
import geo100 from "../img/icon/Icon_geo_100.svg";
import geo50 from "../img/icon/Icon_geo_50.svg";

const FilialBlock = ({ data, setFilialObj, filialObj, errorCity, errorFilial, setErrorFilial, setErrorCity, handleUpdateLocation = () => {}, cityArr = [], className, triggerIcon, offerItem, arrMetroFilial, index, setTriggerIcon }) => {
    const [city, setCity] = useState(false);
    const [filial, setFilial] = useState(false);

    const selectableAddresses = useMemo(() => data?.addresses?.filter((f) => !("isSelect" in f) || f.isSelect) ?? [], [data]);

    useEffect(() => {
        if (!filialObj || !data?.addresses?.length) return;

        const selectedCity = data.addresses.find((item) => item.city === filialObj.city);
        const selectedFilial = selectedCity?.address?.find((item) => item.text === filialObj.filial);

        if (selectedCity) {
            setCity(selectedCity);
            setTriggerIcon((prev) => ({ ...prev, geoCity: 3 }));
        }

        if (selectedFilial) {
            setFilial(selectedFilial);
            setTriggerIcon((prev) => ({ ...prev, geoFilial: 3 }));
        }
    }, [data, filialObj, setTriggerIcon]);

    useEffect(() => {
        if (selectableAddresses.length === 1) {
            setCity(selectableAddresses[0]);
            setErrorCity(false);
        }
    }, [selectableAddresses, setErrorCity]);

    useEffect(() => {
        if (city?.address?.length === 1) {
            setFilialObj({ city: city.city, filial: city.address[0].text });
            setFilial(city.address[0]);
            setTriggerIcon((prev) => {
                return { ...prev, geoFilial: 3 };
            });
        } else {
            if (!filialObj?.filial) {
                setFilial(false);
            }
        }
    }, [city, filialObj?.filial, setFilialObj, setTriggerIcon]);

    const getLocationValue = (selectedCity) => {
        if (!selectedCity) return;

        const matchedCity = cityArr?.find((item) => item.city === selectedCity.city);

        if (!matchedCity) return selectedCity;

        return {
            ...selectedCity,
            _id: selectedCity._id || matchedCity._id,
            regionId: selectedCity.regionId || matchedCity.regionId,
        };
    };
    const handleChange = (el, id) => {
        let nextFilialObj = { ...filialObj };

        if (id === "city") {
            setCity(el);
            nextFilialObj.city = el.city;

            delete nextFilialObj.filial;
            delete nextFilialObj.metro;
            setTriggerIcon((prev) => ({ ...prev, geoMetro: 0 }));
        } else {
            setFilial(el);
            nextFilialObj[id] = el.text;
        }

        if (selectableAddresses.length === 1) {
            nextFilialObj = {
                ...nextFilialObj,
                [id]: el.text,
                city: selectableAddresses[0].city,
            };
        }

        setFilialObj(nextFilialObj);

        handleUpdateLocation(getLocationValue(id === "city" ? el : city || selectableAddresses[0]));
    };

    return (
        <div className="filial__block">
            {selectableAddresses.length === 1 ? null : (
                <div className="form__abtest ">
                    <div className={`line ${triggerIcon.geoCity === 3 ? "green" : ""}`}></div>

                    <div className="icon">
                        {triggerIcon.geoCity === 0 ? <img src={geo} /> : null}
                        {triggerIcon.geoCity === 2 ? <img src={geo50} /> : null}
                        {triggerIcon.geoCity === 3 ? <img src={geo100} /> : null}
                    </div>
                    <SelectFilialUI
                        id={"city"}
                        error={errorCity}
                        setError={setErrorCity}
                        data={selectableAddresses}
                        onChange={handleChange}
                        title={city ? city.city : "Выберите город"}
                        isEmpty={!city}
                        className={className}
                        index={"geoCity"}
                        setTriggerIcon={setTriggerIcon}
                    />
                </div>
            )}

            <div className="form__abtest filial">
                {index !== offerItem?.inputFields?.length - 1 && arrMetroFilial.length ? <div className={`line ${triggerIcon.geoFilial === 3 ? "green" : ""}`}></div> : null}

                <div className="icon">
                    {triggerIcon.geoFilial === 0 ? <img src={filialicon} /> : null}
                    {triggerIcon.geoFilial === 2 ? <img src={filial50} /> : null}
                    {triggerIcon.geoFilial === 3 ? <img src={filial100} /> : null}
                </div>
                <SelectFilialUI
                    error={errorFilial}
                    setError={setErrorFilial}
                    id={"filial"}
                    data={city.address}
                    disable={!city}
                    onChange={handleChange}
                    title={filial ? filial.text : data?.title}
                    city={city}
                    isEmpty={!filial}
                    className={className}
                    index={"geoFilial"}
                    setTriggerIcon={setTriggerIcon}
                />
            </div>
        </div>
    );
};

export default FilialBlock;
